document.addEventListener("DOMContentLoaded", () => {
	const $block = document.querySelector(".b-blog-archive");
	if (!$block || typeof auraBispol === "undefined") return;

	// Initialize Dropdown Toggle for mobile
	const $categoriesContainer = $block.querySelector(
		".b-blog-archive-categories",
	);
	if (!$categoriesContainer) return;

	const initMobileDropdown = () => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const $existingToggle = $block.querySelector(
			".b-blog-archive-categories-toggle",
		);
		const $activeLink = $categoriesContainer.querySelector(
			".b-blog-archive-categories-link.is-active",
		);

		if (isMobile && !$existingToggle) {
			const $firstLink = $categoriesContainer.querySelector(
				".b-blog-archive-categories-link",
			);
			const $toggle = document.createElement("button");
			$toggle.className = "b-blog-archive-categories-toggle";
			$toggle.type = "button";
			$toggle.textContent = $activeLink
				? $activeLink.textContent.trim()
				: $firstLink
					? $firstLink.textContent.trim()
					: "";

			if ($activeLink) {
				$activeLink.classList.add("is-hidden-mobile");
			}

			$toggle.addEventListener("click", () => {
				$categoriesContainer.classList.toggle("is-open");
			});
			$categoriesContainer.parentNode.insertBefore(
				$toggle,
				$categoriesContainer,
			);
		} else if (!isMobile && $existingToggle) {
			$existingToggle.remove();
			if ($activeLink) {
				$activeLink.classList.remove("is-hidden-mobile");
			}
			$categoriesContainer.classList.remove("is-open");
		}
	};

	initMobileDropdown();
	window.addEventListener("resize", initMobileDropdown);
});
